import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as $ from 'jquery';
import * as AOS from 'aos';


@Component({
  selector: 'app-porcentaje-actas',
  templateUrl: './porcentaje-actas.component.html',
  styleUrls: ['./porcentaje-actas.component.css']
})
export class PorcentajeActasComponent implements OnInit {

  // url para compartir en redes sociales
  urlVideo:string = "https://ayuda-pruebas.ine.mx/2018/Computos/assets/videos/Porcentaje_de_Actas_Computadas.mp4";
  tituloEmail = "Compartir el vídeo del Centro de Ayuda";


  constructor(private titleService: Title) { }
  ngOnInit() {

    AOS.init({
      duration: 500,
      easing: 'linear',
    });

    $(document).ready(function(){
      // $(".subrayado").removeClass("subrayado");
      // $("#Porcentajeactas").addClass("subrayado");
      // $('.active-INE').removeClass('active-INE');
      // $(".subrayado").closest('.nav-item').find("a").addClass('active-INE');
      // $("#main").removeClass("m-main-menu");

      var videoNormal = $('.video-normal');

       if ( screen.width < 650 ) {
         videoNormal.prop("muted", true);
         videoNormal.prop("controls", true);
         videoNormal.trigger('pause');
       }else {
         videoNormal.prop("loop", true);
         videoNormal.prop("muted", true);
         videoNormal.prop("controls", true);
         videoNormal.trigger('play');
       }

    });
    this.titleService.setTitle('Porcentaje de Actas computadas | CentroAyuda Cómputos');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/actas/porcentaje-actas/porcentaje-actas.component.ts